var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../../config/api';
export var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSubmitSuccess = _a.onSubmitSuccess, children = _a.children, siteId = _a.siteId;
    var _b = useState({
        nickname: '',
        rentalPeriod: '',
        assemblyFeedback: '',
        review: '',
        recommendation: '',
        rating: 5
    }), formData = _b[0], setFormData = _b[1];
    var _c = useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = useState(null), submissionError = _d[0], setSubmissionError = _d[1];
    var _e = useState(false), submissionSuccess = _e[0], setSubmissionSuccess = _e[1];
    var _f = useState(isOpen), isVisible = _f[0], setIsVisible = _f[1];
    var _g = useState({}), errors = _g[0], setErrors = _g[1];
    // Update visibility when isOpen changes
    useEffect(function () {
        if (isOpen) {
            setIsVisible(true);
        }
        else if (!isSubmitting) {
            // Only hide if not submitting
            setIsVisible(false);
        }
    }, [isOpen, isSubmitting]);
    // Handle ESC key to close modal
    useEffect(function () {
        var handleEscKey = function (event) {
            if (event.key === 'Escape' && isVisible && !isSubmitting) {
                onClose();
            }
        };
        if (isVisible) {
            document.addEventListener('keydown', handleEscKey);
        }
        return function () {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isVisible, isSubmitting, onClose]);
    // Custom close handler to maintain spinner state
    var handleClose = function () {
        if (!isSubmitting) {
            onClose();
        }
    };
    if (!isVisible)
        return null;
    var validateForm = function () {
        var newErrors = {};
        if (!formData.nickname.trim()) {
            newErrors.nickname = 'ニックネームを入力してください';
        }
        else if (formData.nickname.trim().length < 2) {
            newErrors.nickname = 'ニックネームは2文字以上で入力してください';
        }
        if (!formData.recommendation.trim()) {
            newErrors.recommendation = 'ロコミを入力してください';
        }
        else if (formData.recommendation.trim().length < 10) {
            newErrors.recommendation = 'ロコミは10文字以上で入力してください';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var validateField = function (fieldName, value) {
        var newErrors = __assign({}, errors);
        if (fieldName === 'nickname') {
            if (!value.trim()) {
                newErrors.nickname = 'ニックネームを入力してください';
            }
            else if (value.trim().length < 2) {
                newErrors.nickname = 'ニックネームは2文字以上で入力してください';
            }
            else {
                delete newErrors.nickname;
            }
        }
        if (fieldName === 'recommendation') {
            if (!value.trim()) {
                newErrors.recommendation = 'ロコミを入力してください';
            }
            else if (value.trim().length < 10) {
                newErrors.recommendation = 'ロコミは10文字以上で入力してください';
            }
            else {
                delete newErrors.recommendation;
            }
        }
        setErrors(newErrors);
    };
    var handleFormSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPayload, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!validateForm()) {
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    setSubmissionError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    apiPayload = {
                        site_id: siteId,
                        reply_admin_id: '1',
                        nickname: formData.nickname,
                        question_answer_1: formData.rentalPeriod,
                        question_answer_2: formData.assemblyFeedback,
                        question_answer_3: formData.review,
                        question_answer_4: formData.recommendation,
                        question_answer_5: "",
                        reply_text: "",
                        rating: formData.rating.toString(),
                        comment: formData.review
                    };
                    // Make the API POST request
                    return [4 /*yield*/, axios.post("".concat(API_CONFIG.BASE_URL).concat(API_CONFIG.ENDPOINTS.REVIEWS), apiPayload)];
                case 2:
                    // Make the API POST request
                    _a.sent();
                    setSubmissionSuccess(true);
                    // Call the success callback if provided
                    if (onSubmitSuccess) {
                        setTimeout(function () {
                            onSubmitSuccess();
                        }, 1500);
                    }
                    // Keep the spinner running for a moment before closing
                    setTimeout(function () {
                        // First set isSubmitting to false, then close the modal
                        setIsSubmitting(false);
                        onClose();
                        setSubmissionSuccess(false);
                        // Reset the form after everything is done
                        setTimeout(function () {
                            resetForm();
                        }, 500);
                    }, 2000);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error submitting review:', error_1);
                    setSubmissionError('レビューの送信中にエラーが発生しました。後でもう一度お試しください。');
                    setIsSubmitting(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setFormData({
            nickname: '',
            rentalPeriod: '',
            assemblyFeedback: '',
            review: '',
            recommendation: '',
            rating: 5
        });
        setSubmissionError(null);
        setErrors({});
    };
    // Spinner component for the submit button
    var Spinner = function () { return (_jsxs("svg", __assign({ className: "animate-spin -ml-1 mr-2 h-5 w-5 text-white", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, { children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }))); };
    return (_jsx("div", __assign({ className: "fixed inset-0 bg-black/70 flex items-center justify-center z-50 backdrop-blur-sm" }, { children: _jsxs("div", __assign({ className: "bg-white rounded-lg max-w-lg w-full max-h-[70vh] shadow-xl relative overflow-hidden flex flex-col" }, { children: [_jsx("button", __assign({ onClick: handleClose, disabled: isSubmitting, className: "absolute top-4 right-4 z-10 text-gray-500 hover:text-gray-800 transition-colors ".concat(isSubmitting ? 'opacity-50 cursor-not-allowed' : ''), "aria-label": "Close" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" }, { children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M6 18L18 6M6 6l12 12" }) })) })), _jsxs("div", __assign({ className: "overflow-y-auto max-h-[70vh] p-8" }, { children: [_jsxs("div", __assign({ className: "flex flex-col justify-start mb-6 text-left" }, { children: [_jsx("div", __assign({ className: "text-2xl font-bold" }, { children: "\u3054\u8A18\u5165\u304A\u9858\u3044\u3057\u307E\u3059\u3002" })), submissionSuccess && (_jsx("div", __assign({ className: "mt-3 p-3 bg-green-100 text-green-700 rounded-md" }, { children: "\u30EC\u30D3\u30E5\u30FC\u3092\u9001\u4FE1\u3057\u3066\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01" }))), submissionError && (_jsx("div", __assign({ className: "mt-3 p-3 bg-red-100 text-red-700 rounded-md" }, { children: submissionError })))] })), _jsxs("form", __assign({ onSubmit: handleFormSubmit, className: "space-y-5", noValidate: true }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsxs("label", __assign({ htmlFor: "nickname", className: "text-left font-medium mb-1" }, { children: ["\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0 ", _jsx("span", __assign({ className: 'text-red' }, { children: " \u203B" })), " "] })), _jsx("input", { id: "nickname", type: "text", className: "border-2 rounded-md p-3 focus:outline-none transition-colors ".concat(errors.nickname
                                                ? 'border-red bg-red-50 focus:border-red focus:ring-2 focus:ring-red'
                                                : 'border-gray-300 focus:border-blue-500'), value: formData.nickname, onChange: function (e) {
                                                setFormData(__assign(__assign({}, formData), { nickname: e.target.value }));
                                                if (errors.nickname) {
                                                    validateField('nickname', e.target.value);
                                                }
                                            }, onBlur: function (e) { return validateField('nickname', e.target.value); }, placeholder: "\uFF0A\uFF0A\uFF0A\uFF0A", disabled: isSubmitting }), errors.nickname && (_jsx("p", __assign({ className: "text-red text-sm mt-1 font-medium" }, { children: errors.nickname })))] })), _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("label", __assign({ htmlFor: "rentalPeriod", className: "text-left font-medium mb-1" }, { children: "\u30EC\u30F3\u30BF\u30EB\u3057\u305F\u671F\u9593\u3092\u6559\u3048\u3066\u304F\u3060\u3055\u3044" })), _jsx("input", { id: "rentalPeriod", type: "text", className: "border-2 border-gray-300 rounded-md p-3 focus:border-blue-500 focus:outline-none transition-colors", value: formData.rentalPeriod, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { rentalPeriod: e.target.value })); }, placeholder: "\u4F8B\uFF1A1\u9031\u9593\u30012\u304B\u6708", disabled: isSubmitting })] })), _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("label", __assign({ htmlFor: "assemblyFeedback", className: "text-left font-medium mb-1" }, { children: "\u7D44\u307F\u7ACB\u3066\u65B9\u3084\u8A2D\u7F6E\u306B\u554F\u984C\u306F\u3042\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u304B\uFF1F" })), _jsx("input", { id: "assemblyFeedback", type: "text", className: "border-2 border-gray-300 rounded-md p-3 focus:border-blue-500 focus:outline-none transition-colors", value: formData.assemblyFeedback, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { assemblyFeedback: e.target.value })); }, placeholder: "\uFF0A\uFF0A\uFF0A\uFF0A", disabled: isSubmitting })] })), _jsxs("div", __assign({ className: "flex flex-col text-left" }, { children: [_jsx("label", __assign({ htmlFor: "review", className: "text-left font-medium mb-1" }, { children: "\u3054\u5229\u7528\u3044\u305F\u3060\u3044\u305F\u611F\u60F3\u3092\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044" })), _jsx("input", { id: "recommendation", type: "text", className: "border-2 border-gray-300 rounded-md p-3 focus:border-blue-500 focus:outline-none transition-colors", value: formData.review, onChange: function (e) { return setFormData(__assign(__assign({}, formData), { review: e.target.value })); }, placeholder: "\uFF0A\uFF0A\uFF0A\uFF0A", disabled: isSubmitting })] })), _jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsxs("label", __assign({ htmlFor: "recommendation", className: "text-left font-medium mb-1" }, { children: ["\u30ED\u30B3\u30DF ", _jsx("span", __assign({ className: 'text-red' }, { children: " \u203B" }))] })), _jsx("textarea", { id: "review", className: "border-2 rounded-md p-3 h-32 focus:outline-none transition-colors resize-none ".concat(errors.recommendation
                                                ? 'border-red bg-red-50 focus:border-red focus:ring-2 focus:ring-red'
                                                : 'border-gray-300 focus:border-blue-500'), value: formData.recommendation, onChange: function (e) {
                                                setFormData(__assign(__assign({}, formData), { recommendation: e.target.value }));
                                                if (errors.recommendation) {
                                                    validateField('recommendation', e.target.value);
                                                }
                                            }, onBlur: function (e) { return validateField('recommendation', e.target.value); }, placeholder: "\uFF0A\uFF0A\uFF0A\uFF0A", disabled: isSubmitting }), errors.recommendation && (_jsx("p", __assign({ className: "text-red text-sm mt-1 font-medium" }, { children: errors.recommendation })))] })), _jsxs("div", __assign({ className: "flex flex-col mt-4" }, { children: [_jsx("label", __assign({ className: "text-left text-gray-700 font-medium mb-2" }, { children: "\u8A55\u4FA1 " })), _jsx("div", __assign({ className: "flex gap-3" }, { children: [1, 2, 3, 4, 5].map(function (star) { return (_jsx("button", __assign({ type: "button", onClick: function () { return setFormData(__assign(__assign({}, formData), { rating: star })); }, className: "text-3xl transition-colors ".concat(formData.rating >= star ? 'text-yellow' : 'text-gray-300'), "aria-label": "".concat(star, " stars"), disabled: isSubmitting }, { children: "\u2605" }), star)); }) }))] })), _jsxs("div", __assign({ className: "flex flex-wrap gap-4 mt-8" }, { children: [_jsx("button", __assign({ type: "submit", disabled: isSubmitting, className: "\n                flex-1 min-w-[180px] w-full sm:w-auto\n                py-3 bg-red border border-blue-600 rounded-md text-white font-medium\n                hover:bg-blue-700 transition-colors duration-300\n                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2\n                flex items-center justify-center disabled:opacity-70\n              " }, { children: isSubmitting ? (_jsxs(_Fragment, { children: [_jsx(Spinner, {}), _jsx("span", { children: "\u9001\u4FE1\u4E2D..." })] })) : ('レビューを送信') })), _jsx("button", __assign({ type: "button", onClick: resetForm, disabled: isSubmitting, className: "\n                flex-1 min-w-[180px] w-full sm:w-auto\n                py-3 border-2 border-gray-300 rounded-md text-gray-700 font-medium\n                hover:bg-gray-100 transition-colors duration-300\n                focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2\n              " }, { children: "\u30EA\u30BB\u30C3\u30C8" }))] }))] }))] }))] })) })));
};
